import { getMerchantId } from './api.js';
import { addMinutes, format } from 'date-fns';
import PaymentPageSdk from '@raiffeisen-ecom/payment-sdk';

const handlePayment = (paymentId, price, orderId, comment, merchantId) => {
  const currentDate = new Date();

  const expirationDate = addMinutes(currentDate, 10);

  const formattedExpirationDate = format(expirationDate, "yyyy-MM-dd'T'HH:mm:ssxxx");

  const purchaseData = {
    payment_id: paymentId,
  };

  // const paymentPage = new PaymentPageSdk('MA741254', {
  //   url: 'https://pay-test.raif.ru/pay/',
  // });
  const paymentPage = new PaymentPageSdk(merchantId);

  return paymentPage.openPopup({
    amount: price,
    comment: comment,
    orderId: orderId,
    locale: 'ru',
    expirationDate: formattedExpirationDate,
    style: {
      header: {
        titlePlace: 'RIGHT',
      },
    },
    paymentMethod: 'ONLY_SBP',
  });

  // getMerchantId(place_id, token, notificationState)
  //   .then((data) => {
  //     const merchantId = data;
  //     const paymentPage = new PaymentPageSdk(merchantId);

  //     return paymentPage.openPopup({
  //       amount: price,
  //       comment: comment,
  //       orderId: orderId,
  //       locale: 'ru',
  //       expirationDate: formattedExpirationDate,
  //       style: {
  //         header: {
  //           titlePlace: 'RIGHT',
  //         },
  //       },
  //       paymentMethod: 'ONLY_SBP',
  //     });
  //   })
  //   .catch((error) => {
  //     console.error('Error fetching books for merchantId:', error);
  //   });
};
export default handlePayment;
